import { render, staticRenderFns } from "./gotoTop.vue?vue&type=template&id=2f41edf1&scoped=true&"
import script from "./gotoTop.vue?vue&type=script&lang=js&"
export * from "./gotoTop.vue?vue&type=script&lang=js&"
import style0 from "./gotoTop.vue?vue&type=style&index=0&id=2f41edf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41edf1",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/gotoTop.vue
// module id = null
// module chunks = 